export const formatToISODate = (input: string): string => {
    if (!input) return "";
  
    const separator = input.includes("/") ? "/" : input.includes("-") ? "-" : "";
    if (!separator) return "";
  
    const parts = input.split(separator).map((p) => parseInt(p, 10));
    if (parts.length !== 3 || parts.some(isNaN)) return "";
  
    let year, month, day;
  
    // Try detecting format
    if (parts[0] > 999) {
      // YYYY/MM/DD
      [year, month, day] = parts;
    } else if (parts[2] > 999) {
      // Could be MM/DD/YYYY or DD/MM/YYYY
      // Let's check if parts[0] <= 12 → likely MM/DD/YYYY
      if (parts[0] <= 12) {
        [month, day, year] = parts;
      } else {
        // Else assume DD/MM/YYYY
        [day, month, year] = parts;
      }
    } else {
      return "";
    }
  
    // Validate date
    const date = new Date(year, month - 1, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() + 1 !== month ||
      date.getDate() !== day
    ) {
      return "";
    }
  
    // Format as YYYY-MM-DD
    const mm = month < 10 ? `0${month}` : `${month}`;
    const dd = day < 10 ? `0${day}` : `${day}`;
    return `${year}-${mm}-${dd}`;
  };
  